var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"basic_wrap"},[_c('bsHeader',{attrs:{"title":_vm.tit}}),_c('van-address-edit',{attrs:{"area-list":_vm.areaList,"show-search-result":"","area-columns-placeholder":['请选择', '请选择', '请选择'],"address-info":_vm.address},on:{"save":_vm.onSave}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }